import { Component, OnInit, Input } from '@angular/core';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { Subject } from 'rxjs';

@Component({
    selector: 'tam-contact-template',
    templateUrl: './contact-template.component.html',
    styleUrls: ['./contact-template.component.scss'],
    standalone: false
})
export class ContactTemplateComponent implements OnInit {
    @Input() config;
    @Input() valueChangeSubject: Subject<ContactTemplateControlValue>;
    constructor() { }

    ngOnInit() {

    }
}
